/* ==========================================================================
   IP search bar — 2026-10-05 (v2)
   Takes over the query side of the theme's header search (fetching, rendering,
   submit) and leaves the theme in charge of opening, closing and the
   full-screen phone mode. Styling: assets/ip-search.css. Result markup:
   sections/predictive-search.liquid.

   The theme's "search within a product type" select is switched off in
   sections/header-group.json on purpose: storefront search treats
   product_type:"X" AND term as plain words, not as a filter, so the control
   never narrowed anything. Category matches in the dropdown replace it.
   ========================================================================== */
(function () {
  'use strict';

  var RECENT_KEY = 'ips:recent';
  var MAX_RECENT = 6;

  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); } else { document.addEventListener('DOMContentLoaded', fn); }
  }

  function el(tag, cls, text) {
    var node = document.createElement(tag);
    if (cls) { node.className = cls; }
    if (text != null) { node.textContent = text; }
    return node;
  }

  function readRecent() {
    try {
      var list = JSON.parse(window.localStorage.getItem(RECENT_KEY) || '[]');
      return Array.isArray(list) ? list.filter(function (v) { return typeof v === 'string' && v; }).slice(0, MAX_RECENT) : [];
    } catch (e) { return []; }
  }

  function writeRecent(list) {
    try { window.localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, MAX_RECENT))); } catch (e) { /* private mode */ }
  }

  function saveRecent(term) {
    term = (term || '').trim();
    if (term.length < 2) { return; }
    var lower = term.toLowerCase();
    var list = readRecent().filter(function (v) { return v.toLowerCase() !== lower; });
    list.unshift(term);
    writeRecent(list);
  }

  ready(function () {
    var wrap = document.querySelector('.header__search-bar-wrapper');
    if (!wrap || wrap.getAttribute('data-ips')) { return; }

    var bar = wrap.querySelector('.search-bar');
    var input = wrap.querySelector('.search-bar__input');
    var results = wrap.querySelector('.search-bar__results');
    var inner = wrap.querySelector('.search-bar__results-inner');
    var box = wrap.querySelector('.search-bar__inner');
    var closeBtn = wrap.querySelector('.search-bar__close-button');
    var clearBtn = wrap.querySelector('.search-bar__input-clear');
    if (!bar || !input || !results || !inner || !box) { return; }
    wrap.setAttribute('data-ips', '1');

    var data = {};
    try { data = JSON.parse(document.getElementById('ips-data').textContent); } catch (e) { data = {}; }
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || data.rootUrl || '/';
    var searchUrl = data.searchUrl || (root + 'search');
    var predictive = true;
    try { predictive = JSON.parse(document.getElementById('shopify-features').textContent).predictiveSearch !== false; } catch (e) { predictive = true; }

    var active = -1;
    var cache = {};
    var controller = null;
    var timer = null;
    var lastKey = '';
    var typed = null;

    /* --- Field attributes ------------------------------------------------ */
    results.id = results.id || 'ips-results';
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('aria-controls', results.id);
    input.setAttribute('enterkeyhint', 'search');
    input.setAttribute('spellcheck', 'false');
    input.setAttribute('autocapitalize', 'off');

    var hint = el('span', 'ips-kbd', '/');
    hint.setAttribute('aria-hidden', 'true');
    input.parentNode.appendChild(hint);

    var live = el('div', 'visually-hidden');
    live.setAttribute('aria-live', 'polite');
    live.setAttribute('role', 'status');
    wrap.appendChild(live);

    /* Dims the page behind the open dropdown. Purely visual: it takes no
       pointer events, so a click outside still reaches the page and the
       theme's own outside-click handler closes the dropdown. */
    var scrim = el('div', 'ips-scrim');
    scrim.setAttribute('aria-hidden', 'true');
    document.body.appendChild(scrim);

    /* --- Start panel (shown while the field is empty) -------------------- */
    var panel = el('div', 'ips-panel');
    panel.hidden = true;
    var recentSec = el('div', 'ips-sec');
    panel.appendChild(recentSec);

    if (data.tryTerms && data.tryTerms.length) {
      var trySec = el('div', 'ips-sec');
      trySec.appendChild(el('p', 'ips-h', 'Try searching'));
      var chips = el('div', 'ips-chips');
      data.tryTerms.forEach(function (term) {
        var chip = el('button', 'ips-chip', term);
        chip.type = 'button';
        chip.setAttribute('data-ips-fill', term);
        chips.appendChild(chip);
      });
      trySec.appendChild(chips);
      panel.appendChild(trySec);
    }

    if (data.departments && data.departments.length) {
      var deptSec = el('div', 'ips-sec');
      deptSec.appendChild(el('p', 'ips-h', 'Shop by department'));
      var depts = el('ul', 'ips-depts');
      data.departments.forEach(function (dept) {
        var li = el('li');
        var a = el('a', 'ips-link ips-link--cat');
        a.href = dept.u;
        a.appendChild(el('span', null, dept.t));
        li.appendChild(a);
        depts.appendChild(li);
      });
      deptSec.appendChild(depts);
      panel.appendChild(deptSec);
    }

    var foot = el('div', 'ips-foot');
    foot.setAttribute('aria-hidden', 'true');
    [['↑↓', 'navigate'], ['↵', 'select'], ['esc', 'close']].forEach(function (pair) {
      var item = el('span');
      item.appendChild(el('kbd', null, pair[0]));
      item.appendChild(document.createTextNode(pair[1]));
      foot.appendChild(item);
    });
    box.insertBefore(panel, box.firstChild);
    box.appendChild(foot);

    function renderRecent() {
      var list = readRecent();
      recentSec.textContent = '';
      recentSec.hidden = !list.length;
      if (!list.length) { return; }
      var head = el('div', 'ips-sec__head');
      head.appendChild(el('p', 'ips-h', 'Recent searches'));
      var clear = el('button', 'ips-clear', 'Clear');
      clear.type = 'button';
      clear.setAttribute('data-ips-clear', '');
      head.appendChild(clear);
      recentSec.appendChild(head);
      list.forEach(function (term) {
        var row = el('div', 'ips-recent');
        var btn = el('button', 'ips-row ips-row--recent');
        btn.type = 'button';
        btn.setAttribute('data-ips-fill', term);
        btn.appendChild(el('span', null, term));
        var x = el('button', 'ips-recent__x', '×');
        x.type = 'button';
        x.setAttribute('data-ips-remove', term);
        x.setAttribute('aria-label', 'Remove "' + term + '" from recent searches');
        row.appendChild(btn);
        row.appendChild(x);
        recentSec.appendChild(row);
      });
    }

    /* --- Open / close ---------------------------------------------------- */
    function options() {
      var scope = panel.hidden ? results : panel;
      return Array.prototype.filter.call(
        scope.querySelectorAll('a[href], button[data-ips-fill], button.search-bar__view-all'),
        function (node) { return node.offsetParent !== null; }
      );
    }

    /* Arrowing onto a suggested search writes it into the field, the way a
       browser address bar does; arrowing back off restores what was typed. */
    function setActive(index) {
      var list = options();
      list.forEach(function (node) { node.classList.remove('is-active'); });
      active = (index >= 0 && index < list.length) ? index : -1;
      if (active === -1) {
        input.removeAttribute('aria-activedescendant');
        if (typed !== null) { input.value = typed; typed = null; }
        return;
      }
      var node = list[active];
      if (!node.id) { node.id = 'ips-opt-' + Math.random().toString(36).slice(2, 9); }
      node.classList.add('is-active');
      input.setAttribute('aria-activedescendant', node.id);
      if (node.scrollIntoView) { node.scrollIntoView({ block: 'nearest' }); }
      var suggestion = node.getAttribute('data-query');
      if (suggestion) {
        if (typed === null) { typed = input.value; }
        input.value = suggestion;
      } else if (typed !== null) {
        input.value = typed;
        typed = null;
      }
    }

    /* The dropdown may be wider than the field, but never wider than the room
       between the field's left edge and the right edge of the viewport. */
    function fit() {
      var room = document.documentElement.clientWidth - bar.getBoundingClientRect().left - 16;
      box.style.setProperty('--ips-room', Math.max(0, Math.round(room)) + 'px');
    }

    function showPanel() {
      renderRecent();
      fit();
      panel.hidden = false;
      results.setAttribute('aria-hidden', 'true');
      bar.classList.add('is-expanded');
      typed = null;
      setActive(-1);
    }

    function showResults() {
      fit();
      panel.hidden = true;
      results.setAttribute('aria-hidden', 'false');
      bar.classList.add('is-expanded');
    }

    function close() {
      typed = null;
      setActive(-1);
      bar.classList.remove('is-expanded');
      results.setAttribute('aria-hidden', 'true');
      panel.hidden = true;
    }

    function sync() {
      var open = bar.classList.contains('is-expanded');
      input.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.documentElement.classList.toggle('ips-open', open);
    }

    new MutationObserver(sync).observe(bar, { attributes: true, attributeFilter: ['class'] });

    window.addEventListener('resize', function () {
      if (bar.classList.contains('is-expanded')) { fit(); }
    });

    /* --- Fetch + render -------------------------------------------------- */
    function done() { bar.classList.remove('is-loading', 'ips-busy'); }

    function render(html, key) {
      if (key !== lastKey) { return; }
      done();
      inner.innerHTML = html;
      results.scrollTop = 0;
      typed = null;
      setActive(-1);
      var counted = inner.querySelector('[data-count]');
      var count = counted ? parseInt(counted.getAttribute('data-count'), 10) : 0;
      live.textContent = count ? count + ' suggestions available. Use the up and down arrow keys to review.' : 'No suggestions found.';
    }

    function search(term) {
      var key = term.toLowerCase();
      lastKey = key;
      showResults();
      if (cache[key]) { render(cache[key], key); return; }
      if (controller) { controller.abort(); }
      controller = window.AbortController ? new AbortController() : null;
      bar.classList.add(inner.childElementCount ? 'ips-busy' : 'is-loading');

      var url;
      if (predictive) {
        url = root + 'search/suggest?section_id=predictive-search&q=' + encodeURIComponent(term) +
          '&resources[type]=product,collection,query,page&resources[limit]=6&resources[limit_scope]=each' +
          '&resources[options][unavailable_products]=last' +
          '&resources[options][fields]=title,product_type,variants.title,variants.sku,vendor,tag';
      } else {
        url = root + 'search?section_id=predictive-search&type=product&options[prefix]=last&q=' + encodeURIComponent(term);
      }

      fetch(url, { credentials: 'same-origin', signal: controller ? controller.signal : undefined })
        .then(function (response) {
          if (!response.ok) { throw new Error('search ' + response.status); }
          return response.text();
        })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var section = doc.querySelector('.search-ajax');
          var html = section ? section.innerHTML.trim() : '';
          cache[key] = html;
          render(html, key);
        })
        .catch(function (error) {
          if (error && error.name === 'AbortError') { return; }
          if (key === lastKey) { done(); }
        });
    }

    function update() {
      var term = input.value.trim();
      input.classList.toggle('is-filled', input.value !== '');
      if (!term) {
        if (controller) { controller.abort(); }
        lastKey = '';
        done();
        inner.textContent = '';
        showPanel();
        return;
      }
      search(term);
    }

    /* Opens whichever view fits the field's current value. Called from focus,
       click and the keyboard shortcut, because a focus event alone is not
       guaranteed (the field may already hold focus when it is clicked). */
    function open() {
      if (!input.value.trim()) { showPanel(); return; }
      input.classList.add('is-filled');
      if (inner.childElementCount) { showResults(); } else { update(); }
    }

    function fill(term) {
      typed = null;
      input.value = term;
      input.focus();
      update();
    }

    function go(term) {
      term = (term || '').trim();
      if (!term) { input.focus(); open(); return; }
      saveRecent(term);
      window.location.assign(searchUrl + '?type=product&options%5Bprefix%5D=last&q=' + encodeURIComponent(term));
    }

    /* --- Events ----------------------------------------------------------
       Capture-phase listeners on document run before the theme's delegated
       handlers on the wrapper, so stopping propagation here is what hands the
       query side over to this script. */
    document.addEventListener('input', function (event) {
      if (event.target !== input) { return; }
      event.stopPropagation();
      typed = null;
      input.classList.toggle('is-filled', input.value !== '');
      window.clearTimeout(timer);
      timer = window.setTimeout(update, input.value.trim() ? 140 : 0);
    }, true);

    document.addEventListener('submit', function (event) {
      if (event.target !== bar) { return; }
      event.stopPropagation();
      event.preventDefault();
      go(input.value);
    }, true);

    input.addEventListener('focus', function () {
      window.setTimeout(function () {
        if (document.activeElement === input) { open(); }
      }, 0);
    });

    input.addEventListener('click', function () {
      if (!bar.classList.contains('is-expanded')) { open(); }
    });

    input.addEventListener('keydown', function (event) {
      var list;
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        if (!bar.classList.contains('is-expanded')) { open(); return; }
        list = options();
        if (!list.length) { return; }
        event.preventDefault();
        if (event.key === 'ArrowDown') { setActive(active + 1 >= list.length ? -1 : active + 1); }
        else { setActive(active === -1 ? list.length - 1 : active - 1); }
      } else if (event.key === 'Enter') {
        list = options();
        if (active > -1 && list[active]) {
          event.preventDefault();
          event.stopPropagation();
          if (list[active].getAttribute('data-query')) { go(list[active].getAttribute('data-query')); }
          else { list[active].click(); }
        }
      } else if (event.key === 'Escape') {
        event.preventDefault();
        close();
        input.blur();
        if (wrap.classList.contains('is-fixed') && closeBtn) { closeBtn.click(); }
      }
    });

    box.addEventListener('click', function (event) {
      var target = event.target.closest('[data-ips-fill], [data-ips-remove], [data-ips-clear], a[href]');
      if (!target || !box.contains(target)) { return; }
      if (target.hasAttribute('data-ips-fill')) {
        fill(target.getAttribute('data-ips-fill'));
      } else if (target.hasAttribute('data-ips-remove')) {
        var gone = target.getAttribute('data-ips-remove');
        writeRecent(readRecent().filter(function (v) { return v !== gone; }));
        renderRecent();
        input.focus();
      } else if (target.hasAttribute('data-ips-clear')) {
        writeRecent([]);
        renderRecent();
        input.focus();
      } else if (target.getAttribute('data-query')) {
        event.preventDefault();
        go(target.getAttribute('data-query'));
      } else {
        saveRecent(typed !== null ? typed : input.value);
      }
    });

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        window.setTimeout(function () { typed = null; input.focus(); update(); }, 0);
      });
    }

    document.addEventListener('keydown', function (event) {
      var slash = event.key === '/' && !event.ctrlKey && !event.metaKey && !event.altKey;
      var cmdK = (event.key === 'k' || event.key === 'K') && (event.ctrlKey || event.metaKey) && !event.altKey && !event.shiftKey;
      if (!slash && !cmdK) { return; }
      var t = event.target;
      if (slash && t && (t.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName))) { return; }
      if (input.offsetParent === null) { return; }
      event.preventDefault();
      input.focus();
      input.select();
      open();
    });

    /* --- Search results page: put the query back in the field ------------- */
    try {
      if (/\/search\/?$/.test(window.location.pathname)) {
        var q = new URLSearchParams(window.location.search).get('q') || '';
        q = q.replace(/^product_type:(?:"[^"]+"|\S+)(?:\s+AND\s+)?/, '').replace(/\*$/, '').trim();
        if (q) { input.value = q; input.classList.add('is-filled'); }
      }
    } catch (e) { /* leave the field empty */ }
  });
})();
